<template>
    <div class="content">
        <center>
            <h3 style="display:inline-block">Actualizar Banner</h3>
            <i @click="showInfo()" class="el-icon-question help-icon"></i>
        </center>
        <br><br>
        <center>
            <div class="container">
                <div class="row">                
                    <div class="col-md-12">
                        <div class="row form-group">                        
                            <div class="col-md-6">
                                <label class="font-weight-bold">Banner a editar</label><br>
                                <el-select @change="loadBanner($event)" v-model="bannerSelected">
                                    <el-option :selected="true" disabled value="">Seleccione un Banner</el-option>
                                    <el-option
                                        v-for="(item, key) in banners"
                                        :key="key"
                                        :label="item.name"
                                        :value="key"
                                    >
                                    </el-option>
                                </el-select>
                            </div>                                                      
                        </div>                    
                        <div class="row form-group">
                            <div class="col-md-6 mb-3 mb-md-0">
                                <label class="font-weight-bold">Nombre del banner</label>
                                <el-input type="text" v-model="banner" placeholder="Promocion"></el-input>
                            </div>
                            <div class="col-md-6">
                                <label class="font-weight-bold">Imagen de la promocion</label><br>
                                <input type="file" @change="getFiles()" ref="files">
                                <img height="150" :src="this.bannerImage">
                            </div>
                        </div>                                 
                        <div class="row form-group">                        
                            <div class="col-md-4">
                                <label class="font-weight-bold">Descripción</label>
                                <el-input type="text" v-model="descripcion" name="message" placeholder="Texto que aparecerá en la imagen"></el-input>                     
                            </div>                                             
                            <div class="col-md-4">
                                <label class="font-weight-bold">Descripción en inglés</label>
                                <el-input type="text" v-model="descripcionEng" name="message" placeholder="Texto en inglés que aparecerá en la imagen"></el-input>                     
                            </div>                                             
                        </div>                                      
                    </div>                    
                    <div class="row form-group">                        
                        <div class="col-md-12">
                            <input style="margin-top: 10%;" @click="editPromo" value="Actualizar" class="btn btn-primary pill px-4 py-2">
                        </div>
                    </div>
                </div>                
            </div>
        </center>           
    </div>
</template>

<script>
import { db, storage } from '@/firebase.js'
import moment from "moment"

export default {
    data () {
      return {
        /*variables para la info */
        messaje: 'En este módulo le será posible actualizar los datos de un banner ya creado, para comenzar primero necesita seleccionar el banner a editar, luego de esto se cargarán los datos ya almacenados en la base de datos y usted podrá cambiar los necesarios, posteriormente presiona el boton "Actualizar" y la información será actualizada.',
        title: 'Actualizar Banner',
        /*fin variables para info */
        files: [],
        bannerSelected: null,
        bannerImage: null,
        bannerEditar: null,
        /* */
        banner: null,
        descripcionEng:null,       
        descripcion: null,       
        imageInvalid : true,
        /* */
        banners: [],        
        bannersRef: db.child("banner"),
      }
    },    
    methods:{ 
        getFiles() {
            this.files = this.$refs.files.files            
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.hotelImage = fileReader.result
            })
            fileReader.readAsDataURL(this.files[0])
            
        },                
        async editPromo() {            
            try {
                const key = this.bannerSelected;
                const file = this.$refs.files.files[0]
                let url = null
                if(file)
                {
                    url = await (
                        await storage.ref("promos")
                            .child(key)
                            .put(file)
                    ).ref.getDownloadURL() 
                }
                else
                {
                    url = this.oldImage
                }              
                const now = moment()
                const update = {
                    name: this.banner,                    
                    descripcion: this.descripcion,
                    descripcionEng: this.descripcionEng,
                    image: url,
                    createdAt: now.format("DD/MM/YYYY"),
                    createdAtUnix: now.unix() 
                }
                await this.bannersRef.child(key).set(update)
                this.banners = []
                this.banner = null,               
                this.descripcion = null,
                this.descripcionEng = null,
                this.image = null,
                await this.getBanners()
                // Y así puedes handlear el error como te de la puta gana we hee hee ayuwoki
            } catch (ex) {
                return console.error(ex)
            }
            this.success();           
        
        },
        async getBanners () {
            try {
                  this.banners = (
                    await db
                    .child("banner")                    
                    .once("value")                     
                ).val()
            } catch (ex) {
                return console.error(ex)
            }            
        },
        async selectedBanner ( banner ) {            
            try {
                let data = (
                    await db
                    .child("banner")
                    .once("value")                    
                ).val()

                for (let elem in data) {
                    if(elem == banner)
                    {    
                      this.bannerEditar = data[elem]; 
                    }
                } 
                this.oldImage =      this.bannerEditar.image
                this.bannerImage =   this.bannerEditar.image
                this.banner =         this.bannerEditar.name
                this.descripcion =   this.bannerEditar.descripcion
                this.descripcionEng =   this.bannerEditar.descripcionEng

            } catch (ex) {
                return console.error(ex)
            }            
                //console.log(this.hotels)                      
        },         
        loadBanner ( event ) {
            this.selectedBanner ( this.bannerSelected )  
        },
        success () {
            this.$message({
                message: 'Banner actualizado satisfactoriamente.',
                type: 'success'
            });
        },
        failure () {
            this.$message.error('Ha Ocurrido un error, intente de nuevo más tarde');
        },  
        showInfo() {
            this.$alert(this.messaje, this.title, {
                confirmButtonText: 'OK',          
            });
        }        
    }, 
    async created () {
        await this.getBanners()
    }
}
</script>

<style scoped>
   
</style>



// WEBPACK FOOTER //
// Update.vue?47778b91